package com.wintermar.inspection.core.ui.util.modifier

import androidx.compose.foundation.draganddrop.dragAndDropTarget
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.draganddrop.DragAndDropEvent
import androidx.compose.ui.draganddrop.DragAndDropTarget
import androidx.compose.ui.draganddrop.domDataTransferOrNull
import io.github.vinceglb.filekit.PlatformFile
import io.github.vinceglb.filekit.name

@OptIn(ExperimentalComposeUiApi::class)
@Composable
actual fun Modifier.fileDropTarget(
    acceptableExtensions: List<String>,
    onDrop: (List<PlatformFile>) -> Unit
): Modifier {
    val currentOnDrop = rememberUpdatedState(onDrop)
    val currentAcceptableExtensions = rememberUpdatedState(acceptableExtensions)

    val shouldStart = remember {
        { event: DragAndDropEvent ->
            event.transferData != null
        }
    }

    val dropTarget = remember {
        object : DragAndDropTarget {
            override fun onDrop(event: DragAndDropEvent): Boolean {
                val dataTransfer = event.transferData?.domDataTransferOrNull ?: return false
                val fileList = dataTransfer.files
                val files = (0 until fileList.length).mapNotNull { i ->
                    fileList.item(i)?.let { PlatformFile(it) }
                }

                // Filter files by acceptable extensions
                val filteredFiles = if (currentAcceptableExtensions.value.isNotEmpty()) {
                    files.filter { file ->
                        val fileName = file.name.lowercase()
                        currentAcceptableExtensions.value.any { extension ->
                            fileName.endsWith(extension.lowercase())
                        }
                    }
                } else {
                    files
                }

                return if (filteredFiles.isNotEmpty()) {
                    currentOnDrop.value(filteredFiles)
                    true
                } else {
                    false
                }
            }
        }
    }

    return this.dragAndDropTarget(
        shouldStartDragAndDrop = shouldStart,
        target = dropTarget
    )
}

